import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiService } from '../services/api';

export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    apiService.trackEvent('page_view', null, null, location.pathname);
  }, [location.pathname]);

  return null;
}
